module.exports = __webpack_public_path__ + "images/thumb-d7c5d9d756640c18cb87208b2e948c43.jpg";